import { FC, useEffect, useState } from "react";
import { TPrivacyTermsPage } from "@/models/common/common";
import styles from "../../styles/common/HeadSection.module.scss";

const PrivacyDetail: FC<{ pathNameDetail: TPrivacyTermsPage }> = ({
    pathNameDetail,
}) => {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    const getIubendaHtml = (path: TPrivacyTermsPage) => {
        switch (path) {
            case "privacy": {
                return `<a href="https://www.iubenda.com/privacy-policy/31261392" class="iubenda-white iubenda-noiframe iubenda-embed iub-legal-only iubenda-noiframe iub-body-embed" title="Privacy Policy">Privacy Policy</a>`;
            }
            case "cookie-policy": {
                return `<a href="https://www.iubenda.com/privacy-policy/31261392/cookie-policy" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe iub-body-embed" title="Cookie Policy">Cookie Policy</a>`;
            }
            default: {
                return "";
            }
        }
    };

    useEffect(() => {
        // Carica iubenda.js solo sul client dopo l'hydration
        if (isClient && typeof window !== "undefined") {
            const loadIubenda = () => {
                // Verifica se lo script è già stato caricato
                if (
                    document.querySelector(
                        'script[src="https://cdn.iubenda.com/iubenda.js"]'
                    )
                ) {
                    return;
                }
                const script = document.createElement("script");
                script.src = "https://cdn.iubenda.com/iubenda.js";
                script.async = true;
                document.body.appendChild(script);
            };

            // Carica iubenda quando il browser è inattivo o dopo un delay
            if (
                "requestIdleCallback" in window &&
                typeof window.requestIdleCallback === "function"
            ) {
                window.requestIdleCallback(loadIubenda, { timeout: 2000 });
            } else {
                setTimeout(loadIubenda, 2000);
            }
        }
    }, [isClient, pathNameDetail]);

    return (
        <div className={styles.headPaddingContainerPrivacy}>
            <div
                suppressHydrationWarning
                dangerouslySetInnerHTML={{
                    __html: getIubendaHtml(pathNameDetail),
                }}
            />
        </div>
    );
};

export default PrivacyDetail;
